import { createPopper, Options, VirtualElement } from '@popperjs/core';

import { curry } from 'ramda';

const _createPopper = curry((reference: Element | VirtualElement, popper: HTMLElement, options: Partial<Options>) => {
  return createPopper(reference, popper, options);
});

const popper = {
  createPopper: _createPopper,
};
export default popper;
